var _circle, _g, _circle2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "57.022px",
    height: "57.333px",
    viewBox: "0 0 57.022 57.333",
    enableBackground: "new 0 0 57.022 57.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.511,
    cy: 28.822,
    r: 28.511
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.707,44.837V20.738h-4.395v-3.607c3.192-0.324,4.579-2.266,5.227-4.672h4.949v32.378H26.707z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.511,
    cy: 28.511,
    r: 28.511
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.636,43.552c0.324-9.898,3.422-14.016,9.528-18.409c2.22-1.619,3.053-2.96,3.053-4.903 c0-2.543-1.295-3.792-3.7-3.792c-2.036,0-3.654,1.156-5.181,2.915l-3.608-4.209c2.174-2.729,5.042-4.487,9.02-4.487 c5.596,0,9.343,3.099,9.343,8.742c0,4.486-2.22,7.262-5.319,9.574c-4.394,3.284-6.382,5.458-6.614,8.928h12.026v5.643H19.636z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet2);
export default __webpack_public_path__ + "static/media/Bullet2.92d370a5f69d9c0912c68ea1260a3d2d.svg";
export { ForwardRef as ReactComponent };